import React, { useState, useContext } from "react";

import AgGrid from "../../../Base/Components/Tables/AgGrid/AgGrid";
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext"; 

const ListadoRequisaTab = ({
  listadoRequisas,
  loading,
  selectedDetalle,
  setSelectedDetalle,
  setRequisaEdit,
  setShowDialog,
}) => {
  const { userAuth } = useContext(AuthContext);

  const [purchaseShow, setPurchaseShow] = useState(false);
  const [requisaDialog, setRequisaDialog] = useState(false);

  const columns = [
    {
      // ID
      field: "IdPurchaseRequest",
      header: "ID Detalle",
      headerEn: "ID Detail",
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
    },
    {
      // FechaPermiso4
      field: "DateCreated",
      header: "Fecha Creación",
      headerEn: "Date Create",
      className: "colum-width-medium",
      body: (rowData) => rowData.DateCreated,
      align: "center",
      Format: "DateTime",
    },
    {
      // PurchaseRequest
      field: "PurchaseRequest",
      headerEn: "No. Requisition",
      header: "No. Requisa",
      className: "colum-width-medium",
      body: (rowData) => rowData.PurchaseRequest,
      Format: "Modal",
      align: "center",
      Sumary: "count",
      onCellDoubleClicked: ({ data }) => {
        Requisa(data.PurchaseRequest);
      },
    },
    {
      // Area
      field: "Area",
      header: "Área",
      headerEn: "Area",
      className: "medium",
      body: (rowData) => rowData.Area,
    },
    {
      // Priority
      field: "Priority",
      header: "Prioridad",
      headerEn: "Priority",
      className: "small",
      body: (rowData) => ({ ID: rowData.Priority, Estado: rowData.Priority }),
      align: "center",
      Format: "Estado",
    },
    {
      // SolicitaN
      field: "UserRequest",
      header: "Solicita",
      headerEn: "Request",
      className: "colum-width-large",
      body: (rowData) => rowData.UserName,
    },
    {
      // Area
      field: "UserNameAgente",
      header: "Agente Asignado",
      headerEn: "Assigned Agent",
      className: "colum-width-large",
    },
    {
      // UserCreate
      field: "UserName",
      header: "Usuario Creación",
      headerEn: "User Create",
      className: "colum-width-large",
      body: (rowData) => rowData.Usuario,
    },
    {
      // Comment
      field: "Comment",
      header: "Comentario",
      headerEn: "Comment",
      className: "Xlarge",
      flex: 1,
      body: (rowData) => rowData.Comment,
    },
  ];

  const table = {
    Columns: columns,
    Data: listadoRequisas,
    fileName: "RequisasCompras" + new Date().toDateString(),
    loading: loading,
    clases: "tablaListados alturaListado60",
    showModal: (e) => showModal(e),
    key: "IdPurcharesRequest",
    selected: selectedDetalle,
    setSelected: (e) => setSelectedDetalle(e),
  };

  const Requisa = (Id) => {
    setRequisaEdit(Id);
    setShowDialog(true);
  };

  const showModal = (PurchaseRequest) => {
    setPurchaseShow(PurchaseRequest);
    setRequisaDialog(true);
  };
  // Fecha

  return (
    <div>
      <div style={{ height: "83vh" }}>
        <AgGrid table={table} />
      </div>
    </div>
  );
};

export default ListadoRequisaTab;
